/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PlayersIndexPageQueryVariables = {||};
export type PlayersIndexPageQueryResponse = {|
  +playersConnection: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +fullName: string,
      |}
    |}>
  |}
|};
export type PlayersIndexPageQuery = {|
  variables: PlayersIndexPageQueryVariables,
  response: PlayersIndexPageQueryResponse,
|};
*/


/*
query PlayersIndexPageQuery {
  playersConnection: players(sortColumn: "lastName") {
    edges {
      node {
        id
        fullName
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": "playersConnection",
    "args": [
      {
        "kind": "Literal",
        "name": "sortColumn",
        "value": "lastName"
      }
    ],
    "concreteType": "PlayerConnection",
    "kind": "LinkedField",
    "name": "players",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PlayerEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Player",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullName",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "players(sortColumn:\"lastName\")"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PlayersIndexPageQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PlayersIndexPageQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "PlayersIndexPageQuery",
    "operationKind": "query",
    "text": "query PlayersIndexPageQuery {\n  playersConnection: players(sortColumn: \"lastName\") {\n    edges {\n      node {\n        id\n        fullName\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '991ff3f5bfc9267a51a0e231d6741b12';

module.exports = node;
